import React from "react";
import { Heart } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";
import { Section } from "./Section";

interface VolunteerSectionProps {
  volunteer: TransformedProfileData["sections"]["volunteer"]["items"];
}

export const VolunteerSection: React.FC<VolunteerSectionProps> = ({
  volunteer,
}) => {
  return (
    <Section
      id="volunteer"
      title="Volunteer Experience"
      icon={<Heart className="h-5 w-5" />}
    >
      <div className="grid gap-4 md:grid-cols-2">
        {volunteer
          .filter((volunteer) => volunteer.privacy.isVisible)
          .map((volunteer) => (
            <article key={volunteer.id} className="card-apple p-5">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-base font-semibold">{volunteer.role}</h3>
                  <div className="mt-1 text-sm text-secondary">
                    {volunteer.organization}
                  </div>
                  <div className="mt-2 text-xs text-tertiary">
                    {volunteer.start}{" "}
                    {volunteer.end ? `- ${volunteer.end}` : "- Present"}
                  </div>
                  {volunteer.location && (
                    <div className="text-xs text-tertiary">
                      {volunteer.location}
                    </div>
                  )}
                  <p className="mt-2 text-sm text-secondary">
                    {volunteer.description}
                  </p>
                </div>
                {volunteer.logo && (
                  <img
                    src={volunteer.logo}
                    alt={volunteer.organization}
                    className="h-8 w-8 rounded object-contain"
                  />
                )}
              </div>
              {volunteer.link && (
                <a
                  href={volunteer.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 inline-flex items-center gap-1 text-xs text-primary hover:underline"
                >
                  View Organization
                </a>
              )}
            </article>
          ))}
      </div>
    </Section>
  );
};
